import { CaretDown } from "@phosphor-icons/react";
import { Price, Stack, Text } from "flicket-ui";
import { Icon } from "~components";
import { useCheckoutContext } from "~context/checkoutContext";
import { useOrganization } from "~hooks";

export const ExpressCheckoutMobileToggle = ({
  isExpanded,
  setIsExpanded,
}: {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
}) => {
  const { organization } = useOrganization();
  const { totals } = useCheckoutContext();
  return isExpanded ? (
    <Stack
      alignItems={"center"}
      gap={"1/2"}
      cursor={"pointer"}
      width={"fit-content"}
      onClick={() => setIsExpanded(false)}
    >
      <Text
        variant="regular"
        // @ts-expect-error types do not accept an abitrary string value, but this
        // removes the layout shif when trnasitioning between header.S and regular
        lineHeight={"28px"}
      >
        Order summary
      </Text>
      <Icon icon={<CaretDown />} color="N800" />
    </Stack>
  ) : (
    <Stack
      justifyContent={"space-between"}
      alignItems={"center"}
      onClick={() => setIsExpanded(true)}
      cursor={"pointer"}
    >
      <Stack gap={"1/2"} alignItems={"center"}>
        <Text variant="header.S">Total</Text>
        <Icon icon={<CaretDown />} color="N800" />
      </Stack>
      <Text variant="header.S">
        <Price
          price={totals?.remainingPayment}
          currency={organization.currency}
        />
      </Text>
    </Stack>
  );
};
